"use client";

import type { AnchorHTMLAttributes, CSSProperties } from "react";

/** Google Play 公式バッジ（英語・カラー） */
export const GOOGLE_PLAY_BADGE_SRC =
  "/images/native-app/get-it-on-google-play.svg";

const BADGE_ASPECT_RATIO = 238.96 / 70.87;

const sizeMap = {
  sm: { width: 130 },
  md: { width: 155 },
  lg: { width: 180 },
} as const;

type GooglePlayStoreButtonProps = AnchorHTMLAttributes<HTMLAnchorElement> & {
  size?: keyof typeof sizeMap;
  fullWidth?: boolean;
};

export function GooglePlayStoreButton({
  size = "md",
  fullWidth = false,
  className,
  style,
  ...props
}: GooglePlayStoreButtonProps) {
  const width = fullWidth ? undefined : sizeMap[size].width;
  const height =
    width !== undefined ? Math.round(width / BADGE_ASPECT_RATIO) : undefined;

  const rootStyle: CSSProperties = {
    display: "block",
    width: fullWidth ? "100%" : width,
    lineHeight: 0,
    ...style,
  };

  return (
    <a
      {...props}
      className={className}
      aria-label={props["aria-label"] ?? "Get it on Google Play"}
      style={rootStyle}
    >
      <img
        src={GOOGLE_PLAY_BADGE_SRC}
        alt=""
        width={width}
        height={height}
        style={{
          width: fullWidth ? "100%" : width,
          height: "auto",
          display: "block",
        }}
      />
    </a>
  );
}
